import { AbstractStore } from "~/extensions/utils/AbstractStore";
import { reactive } from "vue";
import { Pagination } from "~/extensions/api";
import { RsyncFindConditionValidator } from "~/pages/admin/Rsync/Models/RsyncFindConditionValidator";
import { RsyncFindConditionViewModel } from "~/pages/admin/Rsync/Models/RsyncFindConditionViewModel";
import { RsyncListViewModel } from "~/pages/admin/Rsync/Models/RsyncListViewModel";
import Enumerable from "linq";
import { adminApi } from "~/api/admin/Api";
class Store extends AbstractStore {
    get keyName() {
        return "startAt";
    }
    init() {
        this.condition = new RsyncFindConditionViewModel();
        this.storedCondition = new RsyncFindConditionViewModel();
        this.conditionValid = new RsyncFindConditionValidator(this.condition);
        this.defaultPagination = new Pagination(this.keyName, true);
        this.resetPagination();
    }
    async load() {
        let result = await adminApi.rsync.find(this.condition, this.pagination);
        this.results = Enumerable.from(result.records)
            .select(x => new RsyncListViewModel(x))
            .toArray();
        this.pagination.rowsNumber = result.total;
        this.foundDate = result.executedDate;
    }
    clear() {
        super.clear();
    }
}
export let store = reactive(new Store());
